import React, { Fragment } from 'react'
import Configurator from '../../configurator'
import Cropper from 'react-easy-crop'
import Button from '../../front/components/shared/sn-button'
import classnames from 'classnames'
import {
    i18nWrapper,
    withConnectWrapper,
} from '../../validator'
import { onFileChange } from './actions/on-file-change'
import {
    onCropChange,
    onCropComplete,
    onZoomChange,
} from './actions/on-crop'
import { onModalClose } from './actions/on-modal-close'

class ImageCropper extends Configurator {
    /**
     * Render cropper content
     *
     * @return {*}
     */
    renderModal = () => {
        const {
            busy,
            croppedImage,
            imageSrc,
            crop,
            zoom,
            aspect,
            cropShape,
            t,
        } = this.props

        return (
            <div className={classnames({
                'image-cropper': true,
                'p-3': imageSrc,
            })}>
                {imageSrc && (
                    <Fragment>
                        <div className="crop-container">
                            {busy && croppedImage && (
                                <div className="d-flex align-items-center justify-content-center opacity-05 h-100">
                                    <img
                                        src={croppedImage}
                                        alt=""
                                        className={classnames({
                                            'h-100': true,
                                            'border-radius-50': cropShape === 'round',
                                        })}
                                    />
                                </div>
                            )}
                            {!busy && (
                                <Cropper
                                    image={imageSrc}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={aspect}
                                    cropShape={cropShape || 'rect'}
                                    onCropChange={onCropChange}
                                    onCropComplete={onCropComplete}
                                    onZoomChange={onZoomChange}
                                />
                            )}
                        </div>
                        {!busy && (
                            <div className="controls mt-3">
                                <div className="d-flex flex-row w-100">
                                    <div className="mr-3">
                                        {t('imageUpload.zoom')}:
                                    </div>
                                    <div className="d-flex flex-row align-items-center justify-content-center w-100">
                                        <div className="mr-2">-</div>
                                        <input
                                            className="custom-range w-100"
                                            type="range"
                                            value={zoom}
                                            min={1}
                                            max={5}
                                            step={0.1}
                                            onChange={event => onZoomChange(event.target.value)}
                                        />
                                        <div className="ml-2">+</div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Fragment>
                )}
            </div>
        )
    }

    /**
     * Render gate
     *
     * @return {null|*}
     */
    renderGate = () => {
        const {
            imageSrc,
            t,
            defaultImage,
            cropShape,
        } = this.props

        if (imageSrc) {
            return null
        }

        return (
            <div>
                {defaultImage && (
                    <div className="d-flex align-items-center justify-content-center h-100 mb-3 bg-color-gray-light-1 p-2 max-height-500 overflow-auto">
                        <img
                            src={defaultImage}
                            alt=""
                            className={classnames({
                                'h-100': true,
                                'border-radius-50': cropShape === 'round',
                            })}
                        />
                    </div>
                )}
                <div className="custom-file d-flex h-auto">
                    <input className="custom-file-input d-none" type="file" id="image-upload" onChange={onFileChange} />
                    <label className="btn btn-color-brand mx-auto my-2 btn-lg" htmlFor="image-upload">
                        {t('imageUpload.uploadButton')}
                    </label>
                </div>
            </div>
        )
    }

    /**
     * Render modal footer
     *
     * @return {null|*}
     */
    renderModalFooter = () => {
        const {
            busy,
            onImageSave,
            imageSrc,
            t,
        } = this.props

        if (!imageSrc) {
            return null
        }

        return (
            <div className="modal-footer d-flex justify-content-end">
                <Button
                    className={classnames({
                        'btn btn-md btn-outline-color-gray-dark-3': true,
                        'btn-loading': busy,
                    })}
                    onClick={onModalClose}
                >
                    {t('cancel')}
                </Button>
                <Button
                    className={classnames({
                        'btn btn-md btn-color-brand': true,
                        'btn-loading': busy,
                    })}
                    onClick={() => onImageSave()}
                >
                    {t('save')}
                </Button>
            </div>
        )
    }

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        return (
            <Fragment>
                <div className="modal-content">
                    <div className="position-relative">
                        {this.renderModal()}
                        {this.renderGate()}
                    </div>
                </div>
                {this.renderModalFooter()}
            </Fragment>
        )
    }
}

export default withConnectWrapper(({ imageCropper }, ownProps) => ({
    imageSrc: imageCropper.imageSrc,
    crop: {
        x: imageCropper.crop.x,
        y: imageCropper.crop.y,
    },
    zoom: imageCropper.zoom,
    aspect: ownProps.aspect || imageCropper.aspect,
    croppedAreaPixels: imageCropper.croppedAreaPixels,
    croppedImage: imageCropper.croppedImage,
    busy: imageCropper.busy || imageCropper.isCropping,
}))(i18nWrapper(ImageCropper))
